export const HeadingStyle = {
  baseStyle: {
    fontFamily: "'Poppins', 'Inter', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 600,
    color: 'brand.text',
  },
  variants: {
    // Semantic hierarchy
    pageTitle: {
      fontSize: { base: '24px', md: '28px' },
      fontWeight: 700,
      lineHeight: 1.2,
      color: 'brand.text',
    },
    sectionTitle: {
      fontSize: { base: '18px', md: '22px' },
      fontWeight: 600,
      lineHeight: 1.3,
      color: 'brand.text',
    },
    cardTitle: {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    fieldLabel: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1.4,
      color: 'brand.text',
    },
    caption: {
      fontSize: '12px',
      fontWeight: 400,
      color: 'brand.text.secondary',
    },
    navLink: {
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'none',
      textDecoration: 'none',
    },

    // Legacy (kept during migration)
    b36: { fontSize: 36, lineHeight: 1, marginBottom: '2px' },
    b26: { fontSize: 26, lineHeight: 1, marginBottom: '2px' },
    b18: { fontSize: 18 },
    b16: { fontSize: 16 },
    b14: { fontSize: 14 },
    b12: { fontSize: 12 },
    sectionHeading: {
      fontSize: { base: '24px', md: '28px' },
      fontWeight: 700,
      lineHeight: 1.2,
      color: 'brand.text',
    },
    section: {
      fontSize: { base: '24px', md: '28px' },
      fontWeight: 700,
      lineHeight: 1.2,
      color: 'brand.text',
    },
    elementHeading: {
      fontSize: { base: '24px', md: '28px' },
      lineHeight: 1.2,
      marginBottom: { base: '4px', md: '8px' },
      color: 'brand.text',
    },
    navMenu: {
      fontSize: '14px',
      fontWeight: 600,
      color: 'brand.text',
      textTransform: 'none',
      textDecoration: 'none',
      padding: '0 10px',
      _hover: { textDecoration: 'none', color: 'brand.primary' },
    },
    navActions: {
      fontSize: 16,
      fontWeight: 600,
      color: 'inherit',
      textTransform: 'uppercase',
      textDecoration: 'none',
      padding: '0 10px',
    },
    footer: {
      fontSize: 12,
      fontWeight: 400,
      color: 'brand.text.secondary',
    },
    linkIcon: {
      color: 'brand.primary',
      fontSize: 14,
      fontWeight: 500,
    },
    jobTitle: {
      fontSize: '18px',
      fontWeight: 700,
      textTransform: 'uppercase',
      paddingBottom: '4px',
    },
  },
};
